import React from 'react'
import styled from 'styled-components'
import { color } from '../styles'
import { BORDER_RADIUS, TRANSITION_TIME_MD_MS } from '../styles/mixins/constants'

type Props = {
    isOpen: boolean
    onClick: () => void
}

export const MenuButton = (props: Props): JSX.Element => {
    const { isOpen, onClick } = props
    return (
        <StyledBurger isOpen={isOpen} onClick={onClick}>
            <span />
            <span />
            <span />
        </StyledBurger>
    )
}

export const StyledBurger = styled.div<{ isOpen: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 30px;
    height: 30px;
    border: none;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    outline: none;
    span {
        background-color: ${color.icon.inverted};
        width: 100%;
        height: 2px;
        border-radius: ${BORDER_RADIUS};
        transition: all ${TRANSITION_TIME_MD_MS * 0.75}ms linear;
        position: relative;
        transform-origin: 1px;
        :first-child {
            transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'rotate(0)')};
        }
        :nth-child(2) {
            opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
            transform: ${({ isOpen }) => (isOpen ? 'translateX(20px)' : 'translateX(0)')};
        }
        :nth-child(3) {
            transform: ${({ isOpen }) => (isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
        }
    }
`
